// This file is auto-generated by @hey-api/openapi-ts

import type { Client, ClientMeta, Options as Options2, RequestResult, TDataShape } from './client';
import { client } from './client.gen';
import type { PaymentWidgetControllerV2ConfirmLineItemDonationV2Data, PaymentWidgetControllerV2ConfirmLineItemDonationV2Responses, PaymentWidgetControllerV2FindOneBySlugV2Data, PaymentWidgetControllerV2FindOneBySlugV2Responses, PaymentWidgetControllerV2GetPaymentStatusV2Data, PaymentWidgetControllerV2GetPaymentStatusV2Responses, PaymentWidgetControllerV2QuoteProductCheckoutV2Data, PaymentWidgetControllerV2QuoteProductCheckoutV2Responses, PublicEventControllerGetAttendeesData, PublicEventControllerGetAttendeesResponses, PublicSignUpWidgetControllerCreateSubmissionData, PublicSignUpWidgetControllerCreateSubmissionResponses, PublicSignUpWidgetControllerFindOneBySlugData, PublicSignUpWidgetControllerFindOneBySlugResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Get the public Event attendee list
 */
export const publicEventControllerGetAttendees = <ThrowOnError extends boolean = false>(options: Options<PublicEventControllerGetAttendeesData, ThrowOnError>): RequestResult<PublicEventControllerGetAttendeesResponses, unknown, ThrowOnError> => (options.client ?? client).get<PublicEventControllerGetAttendeesResponses, unknown, ThrowOnError>({ url: '/api/community/{communitySlug}/events/{eventId}/attendees', ...options });

/**
 * Get public signup widget by slug
 */
export const publicSignUpWidgetControllerFindOneBySlug = <ThrowOnError extends boolean = false>(options: Options<PublicSignUpWidgetControllerFindOneBySlugData, ThrowOnError>): RequestResult<PublicSignUpWidgetControllerFindOneBySlugResponses, unknown, ThrowOnError> => (options.client ?? client).get<PublicSignUpWidgetControllerFindOneBySlugResponses, unknown, ThrowOnError>({ url: '/api/community/{communitySlug}/sign-up-widgets/{slug}', ...options });

/**
 * Create public signup widget submission
 */
export const publicSignUpWidgetControllerCreateSubmission = <ThrowOnError extends boolean = false>(options: Options<PublicSignUpWidgetControllerCreateSubmissionData, ThrowOnError>): RequestResult<PublicSignUpWidgetControllerCreateSubmissionResponses, unknown, ThrowOnError> => (options.client ?? client).post<PublicSignUpWidgetControllerCreateSubmissionResponses, unknown, ThrowOnError>({
    url: '/api/community/{communitySlug}/sign-up-widgets/{slug}/submissions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get public payment widget by slug
 */
export const paymentWidgetControllerV2FindOneBySlugV2 = <ThrowOnError extends boolean = false>(options: Options<PaymentWidgetControllerV2FindOneBySlugV2Data, ThrowOnError>): RequestResult<PaymentWidgetControllerV2FindOneBySlugV2Responses, unknown, ThrowOnError> => (options.client ?? client).get<PaymentWidgetControllerV2FindOneBySlugV2Responses, unknown, ThrowOnError>({ url: '/api/v2/community/{communitySlug}/payment-widgets/{slug}', ...options });

/**
 * Recover a Widget SDK payment status
 */
export const paymentWidgetControllerV2GetPaymentStatusV2 = <ThrowOnError extends boolean = false>(options: Options<PaymentWidgetControllerV2GetPaymentStatusV2Data, ThrowOnError>): RequestResult<PaymentWidgetControllerV2GetPaymentStatusV2Responses, unknown, ThrowOnError> => (options.client ?? client).get<PaymentWidgetControllerV2GetPaymentStatusV2Responses, unknown, ThrowOnError>({ url: '/api/v2/community/{communitySlug}/payment-widgets/{slug}/checkout/{paymentReference}/status', ...options });

/**
 * Confirm a line-item payment widget checkout
 */
export const paymentWidgetControllerV2ConfirmLineItemDonationV2 = <ThrowOnError extends boolean = false>(options: Options<PaymentWidgetControllerV2ConfirmLineItemDonationV2Data, ThrowOnError>): RequestResult<PaymentWidgetControllerV2ConfirmLineItemDonationV2Responses, unknown, ThrowOnError> => (options.client ?? client).post<PaymentWidgetControllerV2ConfirmLineItemDonationV2Responses, unknown, ThrowOnError>({
    url: '/api/v2/community/{communitySlug}/payment-widgets/{slug}/checkout/confirm',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Resolve an authoritative Product checkout quote
 */
export const paymentWidgetControllerV2QuoteProductCheckoutV2 = <ThrowOnError extends boolean = false>(options: Options<PaymentWidgetControllerV2QuoteProductCheckoutV2Data, ThrowOnError>): RequestResult<PaymentWidgetControllerV2QuoteProductCheckoutV2Responses, unknown, ThrowOnError> => (options.client ?? client).post<PaymentWidgetControllerV2QuoteProductCheckoutV2Responses, unknown, ThrowOnError>({
    url: '/api/v2/community/{communitySlug}/payment-widgets/{slug}/checkout/quote',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
